export const userObject={
    "per":"",
    "name":"", 
    "lastname":"", 
    "username":"",
    "password":"", 
    "employeeId":"",
    "departmentId":"",
    "positioncode":"", 
    "email":"", 
    "roles":"", 
    "menugroupId":0, 
    "isActive":"1",   
}